import React from "react";

import { Interpretation } from "lib/build/schema";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";
import { useOrgModParams } from "src/features/orgmod";
import { fsnMessages } from "src/messages/fsn";

export function useInterpretations(): readonly [
	boolean,
	Interpretation[],
	(id: string) => Promise<void>
] {
	const { org, mod } = useOrgModParams();

	const [isLoading, setLoading] = React.useState(false);
	const [data, setData] = React.useState<Interpretation[]>([]);

	const createError = useCreateGenericError();

	const fetch = React.useCallback(
		async (id: string) => {
			setLoading(true);
			try {
				const { data } = await api.get<Interpretation[]>(
					`/events/${id}/interpretations?organization=${org}&module=${mod}`
				);
				setLoading(false);
				setData(normalizeInterpretations(data));
			} catch {
				setLoading(false);
				createError();
			}
		},
		[createError, org, mod]
	);

	return [isLoading, data, fetch];
}

function normalizeInterpretations(items: Interpretation[]): Interpretation[] {
	const map = new Map<string, Interpretation>();
	for (const item of items) {
		const key = `${item.vocab}|${item.code}`;
		if (key in fsnMessages) {
			map.set(key, item);
		}
	}
	return Array.from(map.values());
}
